// extracted by mini-css-extract-plugin
export default {"wrapper":"ReferAccessButtonTooltip_wrapper__GqUxH"};